import React from "react";
import { Routes, Route } from "react-router-dom";

import PermissionRoute from "./components/auth/PermissionRoute";

import Login from "./page/login";
import LineCallback from "./page/line_callback.js";
import PolicyPrivacy from "./page/policy_privacy.js";
import TermsUse from "./page/terms_use.js";

// HOMEPAGE (หน้าเว็บสาธารณะ ไม่ต้องล็อกอิน)
import HomePage from "./page/homepage";
import PropertyDetail from "./page/homepage/property.js";
import PropertyList from "./page/homepage/properties.js";
import ArticleList from "./page/homepage/articles.js";
import FavoriteList from "./page/homepage/favorites.js";
import PartnerApply from "./page/homepage/partner.js";
import PartnerStatus from "./page/homepage/partner_status.js";
import PartnerForgot from "./page/homepage/partner_forgot.js";

// ADMIN
import AdminDashboard from "./page/admin/dashboard.js";
import AdminAssets from "./page/admin/assets.js";
import AdminAssetCreate from "./page/admin/asset_create.js";
import AdminPropertyTypes from "./page/admin/property_types.js";
import AdminProjects from "./page/admin/projects.js";
import AdminMarketing from "./page/admin/marketing.js";
import AdminMarketingChannels from "./page/admin/marketing_channels.js";
import AdminCustomers from "./page/admin/customers.js";
import AdminAppointments from "./page/admin/appointments.js";
import AdminPartners from "./page/admin/partners.js";
import AdminReportProperty from "./page/admin/report_property.js";
import AdminReportSales from "./page/admin/report_sales.js";
import AdminRoles from "./page/admin/roles.js";
import AdminUsers from "./page/admin/users.js";
import AdminSettings from "./page/admin/settings.js";
import AdminWatermark from "./page/admin/watermark.js";
import AdminWalletSetting from "./page/admin/wallet_setting.js";
import AdminWalletTopups from "./page/admin/wallet_topups.js";
// จัดการหน้าแรกของเว็บลูกค้า
import AdminHomeHero from "./page/admin/home_hero.js";
import AdminHomeBanner from "./page/admin/home_banner.js";
import AdminHomePost from "./page/admin/home_post.js";
import AdminHomeShortcut from "./page/admin/home_shortcut.js";
import AdminHomeFeature from "./page/admin/home_feature.js";
import AdminHomeArticle from "./page/admin/home_article.js";
// เอกสารนโยบาย/ข้อกำหนด ใช้หน้าจอเดียวกัน ต่างกันที่ prop kind
import AdminHomeLegal from "./page/admin/home_legal.js";

import Notfound from "./page/notfound";

const AppRoutes = () => (
  <Routes>
    {/* ทางเข้าระบบหลังบ้าน — เดิมอยู่ที่ราก ย้ายมาที่นี่เพราะรากเป็นหน้าเว็บฝั่งลูกค้าแล้ว */}
    <Route path="/login" element={<Login />} />
    {/* ปลายทางที่ LINE redirect กลับมา — ต้องตรงกับ LINE_LOGIN_REDIRECT_URI ฝั่ง backend */}
    <Route path="/auth/line/callback" element={<LineCallback />} />
    <Route path="/policy-privacy" element={<PolicyPrivacy />} />
    {/* ข้อกำหนดการใช้งาน : เปิดจากแถบล่างของฟุตเตอร์เว็บลูกค้า */}
    <Route path="/terms-of-use" element={<TermsUse />} />
    {/* หน้าแรกของเว็บ = หน้าฝั่งลูกค้า : เปิดดูได้โดยไม่ต้องล็อกอิน */}
    <Route path="/" element={<HomePage />} />
    {/* รายละเอียดทรัพย์ : เปิดจากการ์ดในหน้าแรก */}
    <Route path="/property/:id" element={<PropertyDetail />} />
    {/* รายการทรัพย์เต็ม + บทความ : เปิดเป็นแท็บใหม่จากปุ่ม "ดูทั้งหมด" และปุ่มค้นหาในหน้าแรก */}
    <Route path="/properties" element={<PropertyList />} />
    <Route path="/articles" element={<ArticleList />} />
    {/* รายการโปรด : เปิดเป็นแท็บใหม่จากปุ่มหัวใจบนเมนู (เก็บที่เครื่องผู้ใช้ ไม่ต้องล็อกอิน) */}
    <Route path="/favorites" element={<FavoriteList />} />
    {/* สมัครเป็นพาร์ตเนอร์ : ฟอร์มหลายขั้นตอน เปิดจากปุ่มบนเมนู/ฟุตเตอร์และแถบชวนในหน้าแรก */}
    <Route path="/partner" element={<PartnerApply />} />
    {/* ติดตามสถานะใบสมัคร : เปิดจากหน้าจบของฟอร์ม (พ่วง ?code= มาให้) หรือพิมพ์เข้ามาเอง */}
    <Route path="/partner/status" element={<PartnerStatus />} />
    {/* ตั้งรหัสผ่านใหม่ของบัญชีพาร์ตเนอร์ : เปิดจากปุ่ม "ลืมรหัสผ่าน" ในกล่องเข้าสู่ระบบ */}
    <Route path="/partner/forgot-password" element={<PartnerForgot />} />

    {/* ===== Protected routes (ตรวจ permission ตามเมนูใน global.js) ===== */}
    <Route element={<PermissionRoute />}>

    {/* Admin */}
    <Route path="/ad/dashboard" element={<AdminDashboard />} />
    <Route path="/ad/assets" element={<AdminAssets />} />
    <Route path="/ad/assets/create" element={<AdminAssetCreate />} />
    {/* แก้ไขทรัพย์ — ฟอร์มเดียวกับหน้าเพิ่ม (มี :uid = โหมดแก้ไข) */}
    <Route path="/ad/assets/:uid/edit" element={<AdminAssetCreate />} />
    {/* ประเภททรัพย์ — ข้อมูล master ที่ใช้ร่วมกันทั้งระบบ */}
    <Route path="/ad/property-types" element={<AdminPropertyTypes />} />
    {/* โครงการ — ข้อมูล master ของทำเล ใช้เติมตำแหน่งที่ตั้งให้ฟอร์มเพิ่มทรัพย์อัตโนมัติ */}
    <Route path="/ad/projects" element={<AdminProjects />} />
    {/* การตลาด — คิวงานโพสต์ทรัพย์ + ข้อมูล master ของช่องทาง */}
    <Route path="/ad/marketing" element={<AdminMarketing />} />
    <Route path="/ad/marketing/channels" element={<AdminMarketingChannels />} />
    <Route path="/ad/customers" element={<AdminCustomers />} />
    <Route path="/ad/appointments" element={<AdminAppointments />} />
    {/* พาร์ตเนอร์ — คิวตรวจใบสมัครนายหน้าภายนอกที่ส่งเข้ามาจาก /partner */}
    <Route path="/ad/partners" element={<AdminPartners />} />
    {/* รายงาน */}
    <Route path="/ad/reports/property" element={<AdminReportProperty />} />
    <Route path="/ad/reports/sales" element={<AdminReportSales />} />
    <Route path="/ad/roles" element={<AdminRoles />} />
    <Route path="/ad/users" element={<AdminUsers />} />
    <Route path="/ad/settings" element={<AdminSettings />} />
    <Route path="/ad/watermark" element={<AdminWatermark />} />
    {/* ตั้งค่าเหรียญ — นโยบายของระบบเหรียญทั้งระบบ (อัตราแลกเปลี่ยน เพดานต่าง ๆ)
        คนละเรื่องกับการปรับยอดของพาร์ตเนอร์รายคน ซึ่งทำจากเมนูพาร์ตเนอร์ */}
    <Route path="/ad/wallet-settings" element={<AdminWalletSetting />} />
    {/* รายการเติมเหรียญ — คิวตรวจคำขอที่พาร์ตเนอร์ส่งเข้ามาพร้อมสลิป
        เหรียญเข้ากระเป๋าตอนอนุมัติเท่านั้น ไม่ใช่ตอนที่คำขอถูกส่ง */}
    <Route path="/ad/wallet/topups" element={<AdminWalletTopups />} />
    {/* จัดการเนื้อหาหน้าแรกของเว็บลูกค้า */}
    <Route path="/ad/home/hero" element={<AdminHomeHero />} />
    <Route path="/ad/home/banners" element={<AdminHomeBanner />} />
    <Route path="/ad/home/post" element={<AdminHomePost />} />
    <Route path="/ad/home/shortcuts" element={<AdminHomeShortcut />} />
    <Route path="/ad/home/features" element={<AdminHomeFeature />} />
    <Route path="/ad/home/articles" element={<AdminHomeArticle />} />
    {/* เอกสารทางกฎหมาย — คนละหน้ากับหน้าแรก แต่ผู้ดูแลแก้จากเมนูกลุ่มเดียวกัน
        key บังคับให้ React สร้าง component ใหม่ตอนสลับเมนู ไม่ใช้ state ของฉบับเดิม */}
    <Route path="/ad/home/privacy" element={<AdminHomeLegal key="privacy" kind="privacy" />} />
    <Route path="/ad/home/terms" element={<AdminHomeLegal key="terms" kind="terms" />} />

    </Route>
    {/* ===== End protected routes ===== */}

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
